import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccountSetup = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 672,
	height: 896,
	viewBox: "0 0 672 896",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3670_68808)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 224,
				height: 224,
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M224 -2.58033e-05L-9.09197e-06 -1.52588e-05L0 224C123.694 224 224 123.731 224 -2.58033e-05Z",
				fill: "#105ED5"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 224,
				height: 224,
				transform: "translate(224)",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M448 224L448 0L224 0C224 123.694 324.269 224 448 224Z",
				fill: "#FD8F52"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 224,
				height: 224,
				transform: "translate(448)",
				fill: "#FD8F52"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 224,
				height: 224,
				transform: "translate(0 224)",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.32391e-06 224L-1.52588e-05 448L224 448C224 324.306 123.731 224 4.32391e-06 224Z",
				fill: "#105ED5"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 224,
				height: 224,
				transform: "translate(224 224)",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M224 448L448 448L448 224C324.306 224 224 324.269 224 448Z",
				fill: "#002266"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 224,
				height: 224,
				transform: "translate(448 224)",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M448 448L672 448L672 224C548.306 224 448 324.269 448 448Z",
				fill: "#002266"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 224,
				height: 224,
				transform: "translate(0 448)",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.32391e-06 448L-1.52588e-05 672L224 672C224 548.306 123.731 448 4.32391e-06 448Z",
				fill: "#FD8F52"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 224,
				height: 224,
				transform: "translate(224 448)",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M448 448L224 448L224 672C347.694 672 448 571.731 448 448Z",
				fill: "#002266"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 224,
				height: 224,
				transform: "translate(448 448)",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M672 448L448 448L448 672C571.694 672 672 571.731 672 448Z",
				fill: "#002266"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 224,
				height: 224,
				transform: "translate(0 672)",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.32391e-06 672L-1.52588e-05 896L224 896C224 772.306 123.731 672 4.32391e-06 672Z",
				fill: "#002266"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 224,
				height: 224,
				transform: "translate(224 672)",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M224 896L448 896L448 672C324.306 672 224 772.269 224 896Z",
				fill: "#105ED5"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 224,
				height: 224,
				transform: "translate(448 672)",
				fill: "#FFE6D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M448 896L672 896L672 672C548.306 672 448 772.269 448 896Z",
				fill: "#105ED5"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3670_68808",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 672,
			height: 896,
			rx: 32,
			fill: "white"
		})
	}) })]
});
export { SvgAccountSetup as ReactComponent };
